import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconStamp } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/case-study',
  redirect: '/case-study/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '案例研究',
    icon: IconStamp,
    order: 1200,
  },
  children: [
    // 案例配置
    {
      path: 'index',
      component: () => import('@/views/case-study/index.vue'),
      meta: {
        title: '案例配置',
      },
    },
    {
      path: 'add',
      component: () => import('@/views/case-study/add-edit.vue'),
      meta: {
        title: '新增案例',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/index',
      },
    },
    {
      path: 'edit/:id',
      component: () => import('@/views/case-study/add-edit.vue'),
      props: true,
      meta: {
        title: '修改案例',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/index',
      },
    },

    // 行业配置
    {
      path: 'industry/index',
      component: () => import('@/views/case-study/industry/index.vue'),
      meta: {
        title: '行业配置',
      },
    },
    {
      path: 'industry/add',
      component: () => import('@/views/case-study/industry/add-edit.vue'),
      meta: {
        title: '新增行业',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/industry/index',
      },
    },
    {
      path: 'industry/edit/:id',
      component: () => import('@/views/case-study/industry/add-edit.vue'),
      props: true,
      meta: {
        title: '修改行业',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/industry/index',
      },
    },

    // 项目配置
    {
      path: 'project/index',
      component: () => import('@/views/case-study/project/index.vue'),
      meta: {
        title: '项目配置',
      },
    },
    {
      path: 'project/add',
      component: () => import('@/views/case-study/project/add-edit.vue'),
      meta: {
        title: '新增项目',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/project/index',
      },
    },
    {
      path: 'project/edit/:id',
      component: () => import('@/views/case-study/project/add-edit.vue'),
      props: true,
      meta: {
        title: '修改项目',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/case-study/project/index',
      },
    },
  ],
};

export default routes;
